import React, { useState, useEffect, useCallback } from 'react';
import './LiquidacionVales.css';
import { useSelector } from 'react-redux';
import apiService from "../../../../actions/services";

// Definir los estados fuera del componente para reutilizarlos - NUEVA ESTRUCTURA
const ESTADOS = [
  { id: 1, nombre: "Creado", color: "#FF6B6B", icon: "📝" },
  { id: 2, nombre: "Autorizado", color: "#FFA726", icon: "✅" },
  { id: 3, nombre: "Asignado", color: "#42A5F5", icon: "👤" },
  { id: 4, nombre: "Recolectado", color: "#66BB6A", icon: "📦" },
  { id: 5, nombre: "No Recolectado", color: "#EF5350", icon: "❌" },
  { id: 6, nombre: "Recibido", color: "#AB47BC", icon: "🏢" },
  { id: 7, nombre: "Liquidado", color: "#26A69A", icon: "💾" },
  { id: 8, nombre: "SAP", color: "#5D4037", icon: "🚀" }
];

// Definir constantes para estados y motivos fuera de los componentes
const estadosDevolucion = {
  1: 'Creado',
  2: 'Autorizado',
  3: 'Asignado',
  4: 'Recolectado',
  5: 'No Recolectado',
  6: 'Recibido',
  7: 'Liquidado',
  8: 'SAP'
};

const motivosDevolucion = {
  1: { texto: "Cambio de Precio", color: "#FF9800" },
  3: { texto: "Dañado", color: "#F44336" },
  4: { texto: "Devolución Cliente", color: "#9C27B0" },
  5: { texto: "Exceso Inventario", color: "#3F51B5" },
  6: { texto: "Fecha Vencimiento", color: "#2196F3" },
  9: { texto: "Vencido", color: "#607D8B" },
  11: { texto: "Otro", color: "#795548" }
};

// Componente de Notificaciones
const NotificationSystem = ({ notifications, onRemoveNotification }) => {
  return (
    <div className="notification-container">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`notification ${notification.type}`}
        >
          <div className="notification-icon">
            {notification.type === 'success' && '✅'}
            {notification.type === 'error' && '❌'}
            {notification.type === 'warning' && '⚠️'}
            {notification.type === 'info' && 'ℹ️'}
          </div>
          <div className="notification-content">
            <div className="notification-title">{notification.title}</div>
            <div className="notification-message">{notification.message}</div>
          </div>
          <button
            className="notification-close"
            onClick={() => onRemoveNotification(notification.id)}
          >
            ×
          </button>
          <div className="notification-progress"></div>
        </div>
      ))}
    </div>
  );
};

// Componente Autocompletar
const Autocompletar = ({ 
  value, 
  onChange, 
  opciones, 
  placeholder, 
  onSeleccionar,
  mostrarLista,
  onMostrarListaChange
}) => {
  const [inputValue, setInputValue] = useState(value || '');
  const [filtradoOpciones, setFiltradoOpciones] = useState([]);

  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  const handleInputChange = (e) => {
    const nuevoValor = e.target.value;
    setInputValue(nuevoValor);
    onChange(nuevoValor);

    // Filtrar opciones basado en el input
    if (nuevoValor.trim() === '') {
      setFiltradoOpciones(opciones.slice(0, 10));
    } else {
      const filtrado = opciones.filter(opcion => 
        opcion.texto.toLowerCase().includes(nuevoValor.toLowerCase())
      ).slice(0, 10);
      setFiltradoOpciones(filtrado);
    }

    if (!mostrarLista) {
      onMostrarListaChange(true);
    }
  };

  const handleSeleccionar = (opcion) => {
    setInputValue(opcion.texto);
    onChange(opcion.texto);
    onSeleccionar(opcion.valor);
    onMostrarListaChange(false);
  };

  const handleFocus = () => {
    if (inputValue.trim() === '') {
      setFiltradoOpciones(opciones.slice(0, 10));
    }
    onMostrarListaChange(true);
  };

  const handleBlur = (e) => {
    setTimeout(() => {
      onMostrarListaChange(false);
    }, 200);
  };

  return (
    <div className="autocompletar-container">
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        className="autocompletar-input"
      />
      {mostrarLista && filtradoOpciones.length > 0 && (
        <div className="autocompletar-lista">
          {filtradoOpciones.map((opcion, index) => (
            <div
              key={index}
              className="autocompletar-opcion"
              onClick={() => handleSeleccionar(opcion)}
            >
              <span className="opcion-texto">{opcion.texto}</span>
              {opcion.count && (
                <span className="opcion-count">({opcion.count})</span>
              )}
            </div>
          ))}
        </div>
      )}
      {mostrarLista && filtradoOpciones.length === 0 && inputValue.trim() !== '' && (
        <div className="autocompletar-lista">
          <div className="autocompletar-opcion no-resultados">
            No se encontraron resultados
          </div>
        </div>
      )}
    </div>
  );
};

// Componente Autocompletar para Productos
const AutocompletarProductos = ({ 
  value, 
  onChange, 
  onSeleccionar,
  mostrarLista,
  onMostrarListaChange,
  placeholder = "Buscar producto...",
  productosCatalogo = []
}) => {
  const [inputValue, setInputValue] = useState(value || '');
  const [filtradoOpciones, setFiltradoOpciones] = useState([]);

  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  const handleInputChange = (e) => {
    const nuevoValor = e.target.value;
    setInputValue(nuevoValor);
    onChange(nuevoValor);

    // Filtrar productos basado en el input
    if (nuevoValor.trim() === '') {
      setFiltradoOpciones(productosCatalogo.slice(0, 8));
    } else {
      const filtrado = productosCatalogo.filter(producto => 
        producto.ID_Producto.toLowerCase().includes(nuevoValor.toLowerCase()) ||
        producto.ItemName.toLowerCase().includes(nuevoValor.toLowerCase())
      ).slice(0, 8);
      setFiltradoOpciones(filtrado);
    }

    if (!mostrarLista) {
      onMostrarListaChange(true);
    }
  };

  const handleSeleccionar = (producto) => {
    setInputValue(`${producto.ID_Producto} - ${producto.ItemName}`);
    onChange(`${producto.ID_Producto} - ${producto.ItemName}`);
    onSeleccionar(producto);
    onMostrarListaChange(false);
  };

  const handleFocus = () => {
    if (inputValue.trim() === '') {
      setFiltradoOpciones(productosCatalogo.slice(0, 8));
    }
    onMostrarListaChange(true);
  };

  const handleBlur = (e) => {
    setTimeout(() => {
      onMostrarListaChange(false);
    }, 200);
  };

  return (
    <div className="autocompletar-container">
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        className="autocompletar-input"
      />
      {mostrarLista && filtradoOpciones.length > 0 && (
        <div className="autocompletar-lista productos-lista">
          {filtradoOpciones.map((producto, index) => (
            <div
              key={index}
              className="autocompletar-opcion"
              onClick={() => handleSeleccionar(producto)}
            >
              <div className="producto-info">
                <span className="producto-codigo">{producto.ID_Producto}</span>
                <span className="producto-nombre">{producto.ItemName}</span>
              </div>
            </div>
          ))}
        </div>
      )}
      {mostrarLista && filtradoOpciones.length === 0 && inputValue.trim() !== '' && (
        <div className="autocompletar-lista">
          <div className="autocompletar-opcion no-resultados">
            No se encontraron productos
          </div>
        </div>
      )}
    </div>
  );
};

// Modal para confirmar recepción - VERSIÓN MODIFICADA
const ModalRecepcion = ({ devolucion, onClose, onConfirmarRecepcion, productosCatalogo }) => {
  const { user } = useSelector(state => state.auth);
  const [productosRecepcion, setProductosRecepcion] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [mostrarAutocompletar, setMostrarAutocompletar] = useState({});

  // Inicializar los datos de recepción
  useEffect(() => {
    if (devolucion && devolucion.DEV_DET) {
      const productosIniciales = devolucion.DEV_DET.map(producto => ({
        ...producto,
        ID_Producto_Original: producto.ID_Producto,
        ItemName_Original: producto.ItemName,
        ID_Producto_Recepcion: producto.ID_Producto,
        ItemName_Recepcion: producto.ItemName,
        cantidadOriginal: producto.Cantidad,
        cantidadRecepcion: producto.Cantidad,
        observaciones: '',
        modificado: false,
        tipo: 'original',
        mostrarAutocompletar: false
      }));
      setProductosRecepcion(productosIniciales);
    }
  }, [devolucion]);

  const handleCantidadChange = (idProducto, nuevaCantidad) => {
    setProductosRecepcion(prev =>
      prev.map(producto =>
        producto.ID_Devolucion_Detalle === idProducto
          ? { 
              ...producto, 
              cantidadRecepcion: parseInt(nuevaCantidad) || 0,
              modificado: nuevaCantidad !== producto.cantidadOriginal || producto.modificado
            }
          : producto
      )
    );
  };

  const handleObservacionesChange = (idProducto, observaciones) => {
    setProductosRecepcion(prev =>
      prev.map(producto =>
        producto.ID_Devolucion_Detalle === idProducto
          ? { ...producto, observaciones }
          : producto
      )
    );
  };

  const handleProductoChange = (idProducto, nuevoProducto) => {
    setProductosRecepcion(prev =>
      prev.map(producto =>
        producto.ID_Devolucion_Detalle === idProducto
          ? { 
              ...producto, 
              ID_Producto_Recepcion: nuevoProducto.ID_Producto,
              ItemName_Recepcion: nuevoProducto.ItemName,
              Lote: nuevoProducto.Lote,
              Fecha_Vencimiento: nuevoProducto.Fecha_Vencimiento,
              modificado: true,
              mostrarAutocompletar: false
            }
          : producto
      )
    );
    setMostrarAutocompletar(prev => ({ ...prev, [idProducto]: false }));
  };

  const toggleAutocompletar = (idProducto, mostrar) => {
    setMostrarAutocompletar(prev => ({ ...prev, [idProducto]: mostrar }));
  };

  const agregarLinea = () => {
    const nuevaLinea = {
      ID_Devolucion_Detalle: `nuevo-${Date.now()}`,
      ID_Producto_Original: null,
      ItemName_Original: null,
      ID_Producto_Recepcion: '',
      ItemName_Recepcion: '',
      cantidadOriginal: 0,
      cantidadRecepcion: 1,
      observaciones: '',
      Lote: '',
      Fecha_Vencimiento: '',
      ID_Motivo_Devolucion: 11, // Otro por defecto
      modificado: false,
      tipo: 'nuevo',
      mostrarAutocompletar: false
    };
    setProductosRecepcion(prev => [...prev, nuevaLinea]);
  };

  const eliminarLinea = (idProducto) => {
    if (idProducto.toString().startsWith('nuevo-')) {
      setProductosRecepcion(prev => prev.filter(p => p.ID_Devolucion_Detalle !== idProducto));
    }
  };

  const handleConfirmar = async () => {
    setCargando(true);
    try {
      // Preparar el JSON para enviar a la API
      const datosRecepcion = {
        ID_Vale: devolucion.ID_Vale,
        ID_Devolucion: devolucion.ID_Devolucion,
        productos: productosRecepcion.map(producto => ({
          ID_Devolucion_Detalle: producto.tipo === 'nuevo' ? null : producto.ID_Devolucion_Detalle,
          ID_Producto_Original: producto.ID_Producto_Original,
          ID_Producto_Recepcion: producto.ID_Producto_Recepcion,
          ItemName_Original: producto.ItemName_Original,
          ItemName_Recepcion: producto.ItemName_Recepcion,
          cantidadOriginal: producto.cantidadOriginal,
          cantidadRecepcion: producto.cantidadRecepcion,
          observaciones: producto.observaciones,
          lote: producto.Lote,
          fechaVencimiento: producto.Fecha_Vencimiento,
          motivoDevolucion: producto.ID_Motivo_Devolucion,
          modificado: producto.modificado,
          tipo: producto.tipo
        })),
        fechaRecepcion: new Date().toISOString(),
        usuario: user.id_usuario || 'Sistema'
      };

      console.log('Datos de recepción a enviar:', datosRecepcion);

      // Llamar a la función de confirmación
      await onConfirmarRecepcion(datosRecepcion);

    } catch (error) {
      console.error('Error al confirmar recepción:', error);
    } finally {
      setCargando(false);
    }
  };

  const totalProductosOriginal = productosRecepcion
    .filter(p => p.tipo === 'original')
    .reduce((sum, p) => sum + p.cantidadOriginal, 0);
  
  const totalProductosRecepcion = productosRecepcion.reduce((sum, p) => sum + p.cantidadRecepcion, 0);

  const productosModificados = productosRecepcion.filter(p => p.modificado || p.tipo === 'nuevo').length;

  if (!devolucion) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content-recepcion">
        <div className="modal-header">
          <h2>📥 Confirmar Recepción de Devolución</h2>
          <button className="btn-cerrar-modal" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {/* Información General */}
          <div className="seccion-info-general">
            <h3>Información General</h3>
            <div className="info-grid-modal">
              <div className="info-item-modal">
                <label>Vale:</label>
                <span>{devolucion.ID_Vale}</span>
              </div>
              <div className="info-item-modal">
                <label>Cliente:</label>
                <span>{devolucion.Cliente}</span>
              </div>
              <div className="info-item-modal">
                <label>Ruta:</label>
                <span>{devolucion.Ruta}</span>
              </div>
              <div className="info-item-modal">
                <label>Fecha Ruta:</label>
                <span>{new Date(devolucion.Fecha_Ruta).toLocaleDateString()}</span>
              </div>
              <div className="info-item-modal">
                <label>Productos Modificados:</label>
                <span className={productosModificados > 0 ? 'modificado' : ''}>
                  {productosModificados} producto{productosModificados !== 1 ? 's' : ''}
                </span>
              </div>
            </div>
          </div>

          {/* Lista de Productos para Recepción */}
          <div className="seccion-productos-recepcion">
            <div className="seccion-header">
              <h3>Productos a Recibir</h3>
              <button 
                className="btn-agregar-linea"
                onClick={agregarLinea}
                type="button"
              >
                <span className="btn-icon">➕</span>
                Agregar Línea
              </button>
            </div>
            
            <div className="productos-recepcion-header">
              <div className="producto-col producto-acciones-modal">Acciones</div>
              <div className="producto-col producto-cod-modal">Código</div>
              <div className="producto-col producto-nombre-modal">Producto</div>
              <div className="producto-col producto-cantidad-modal">Cant. Original</div>
              <div className="producto-col producto-recepcion-modal">Cant. Recepción</div>
              <div className="producto-col producto-lote-modal">Lote</div>
              <div className="producto-col producto-motivo-modal">Motivo</div>
              <div className="producto-col producto-observaciones-modal">Observaciones</div>
            </div>

            <div className="productos-recepcion-lista">
              {productosRecepcion.map((producto, index) => (
                <div key={producto.ID_Devolucion_Detalle} className={`producto-recepcion-item ${producto.modificado ? 'modificado' : ''} ${producto.tipo === 'nuevo' ? 'nuevo' : ''}`}>
                  <div className="producto-col producto-acciones-modal">
                    {producto.tipo === 'nuevo' && (
                      <button
                        className="btn-eliminar-linea"
                        onClick={() => eliminarLinea(producto.ID_Devolucion_Detalle)}
                        title="Eliminar línea"
                      >
                        🗑️
                      </button>
                    )}
                    {producto.tipo === 'original' && producto.modificado && (
                      <span className="badge-modificado" title="Producto modificado">🔄</span>
                    )}
                  </div>
                  
                  <div className="producto-col producto-cod-modal">
                    {producto.tipo === 'original' ? (
                      <div className="producto-codigo-container">
                        <span 
                          className={`producto-codigo ${producto.ID_Producto_Recepcion !== producto.ID_Producto_Original ? 'modificado' : ''}`}
                          onClick={() => toggleAutocompletar(producto.ID_Devolucion_Detalle, true)}
                          title="Haz clic para cambiar el producto"
                        >
                          {producto.ID_Producto_Recepcion}
                        </span>
                        {mostrarAutocompletar[producto.ID_Devolucion_Detalle] && (
                          <AutocompletarProductos
                            value={`${producto.ID_Producto_Recepcion} - ${producto.ItemName_Recepcion}`}
                            onChange={() => {}}
                            onSeleccionar={(nuevoProducto) => handleProductoChange(producto.ID_Devolucion_Detalle, nuevoProducto)}
                            mostrarLista={mostrarAutocompletar[producto.ID_Devolucion_Detalle]}
                            onMostrarListaChange={(mostrar) => toggleAutocompletar(producto.ID_Devolucion_Detalle, mostrar)}
                            placeholder="Buscar producto..."
                            productosCatalogo={productosCatalogo}
                          />
                        )}
                      </div>
                    ) : (
                      <AutocompletarProductos
                        value={producto.ID_Producto_Recepcion ? `${producto.ID_Producto_Recepcion} - ${producto.ItemName_Recepcion}` : ''}
                        onChange={() => {}}
                        onSeleccionar={(nuevoProducto) => handleProductoChange(producto.ID_Devolucion_Detalle, nuevoProducto)}
                        mostrarLista={mostrarAutocompletar[producto.ID_Devolucion_Detalle]}
                        onMostrarListaChange={(mostrar) => toggleAutocompletar(producto.ID_Devolucion_Detalle, mostrar)}
                        placeholder="Buscar producto..."
                        productosCatalogo={productosCatalogo}
                      />
                    )}
                  </div>
                  
                  <div className="producto-col producto-nombre-modal">
                    <span 
                      className={`producto-nombre ${producto.ItemName_Recepcion !== producto.ItemName_Original ? 'modificado' : ''}`}
                      title={producto.ItemName_Recepcion}
                    >
                      {producto.ItemName_Recepcion}
                    </span>
                    {producto.tipo === 'original' && producto.ID_Producto_Original !== producto.ID_Producto_Recepcion && (
                      <div className="producto-original-info">
                        <small>Original: {producto.ID_Producto_Original} - {producto.ItemName_Original}</small>
                      </div>
                    )}
                  </div>
                  
                  <div className="producto-col producto-cantidad-modal">
                    <span className="cantidad-original">
                      {producto.cantidadOriginal}
                    </span>
                  </div>
                  
                  <div className="producto-col producto-recepcion-modal">
                    <input
                      type="number"
                      min="0"
                      max={producto.tipo === 'nuevo' ? 999 : producto.cantidadOriginal}
                      value={producto.cantidadRecepcion}
                      onChange={(e) => handleCantidadChange(producto.ID_Devolucion_Detalle, e.target.value)}
                      className="input-cantidad-recepcion"
                    />
                  </div>
                  
                  <div className="producto-col producto-lote-modal">
                    {producto.Lote || "N/A"}
                  </div>
                  
                  <div className="producto-col producto-motivo-modal">
                    <span
                      className="motivo-badge"
                      style={{
                        backgroundColor: motivosDevolucion[producto.ID_Motivo_Devolucion]?.color + '20',
                        color: motivosDevolucion[producto.ID_Motivo_Devolucion]?.color,
                        borderColor: motivosDevolucion[producto.ID_Motivo_Devolucion]?.color
                      }}
                    >
                      {motivosDevolucion[producto.ID_Motivo_Devolucion]?.texto || `Motivo ${producto.ID_Motivo_Devolucion}`}
                    </span>
                  </div>
                  
                  <div className="producto-col producto-observaciones-modal">
                    <input
                      type="text"
                      value={producto.observaciones}
                      onChange={(e) => handleObservacionesChange(producto.ID_Devolucion_Detalle, e.target.value)}
                      placeholder="Observaciones..."
                      className="input-observaciones"
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Totales */}
            <div className="recepcion-totales">
              <div className="total-item">
                <span className="total-label">Total Original:</span>
                <span className="total-value">{totalProductosOriginal} unidades</span>
              </div>
              <div className="total-item">
                <span className="total-label">Total Recepción:</span>
                <span className="total-value">{totalProductosRecepcion} unidades</span>
              </div>
              <div className="total-item diferencia">
                <span className="total-label">Diferencia:</span>
                <span className="total-value">
                  {totalProductosRecepcion - totalProductosOriginal} unidades
                </span>
              </div>
              <div className="total-item modificados">
                <span className="total-label">Productos Modificados:</span>
                <span className="total-value">{productosModificados} items</span>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-cancelar" onClick={onClose} disabled={cargando}>
            Cancelar
          </button>
          <button
            className="btn-confirmar-recepcion"
            onClick={handleConfirmar}
            disabled={cargando || totalProductosRecepcion === 0}
          >
            {cargando ? (
              <>
                <span className="btn-spinner"></span>
                Procesando...
              </>
            ) : (
              <>
                <span className="btn-icon">✅</span>
                Confirmar Recepción ({productosModificados > 0 ? 'Con Cambios' : 'Sin Cambios'})
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

// Modal para confirmar liquidación
const ModalLiquidacion = ({ devolucion, onClose, onConfirmarLiquidacion }) => {
  const { user } = useSelector(state => state.auth);
  const [cargando, setCargando] = useState(false);

  const handleConfirmar = async () => {
    setCargando(true);
    try {
      // Preparar datos para liquidación (solo lo necesario)
      const datosLiquidacion = {
        ID_Vale: devolucion.ID_Vale,
        ID_Devolucion: devolucion.ID_Devolucion,
        usuario: user.id_usuario || 'Sistema'
      };

      console.log('Datos de liquidación a enviar:', datosLiquidacion);

      // Llamar a la función de confirmación
      await onConfirmarLiquidacion(datosLiquidacion);

    } catch (error) {
      console.error('Error al confirmar liquidación:', error);
    } finally {
      setCargando(false);
    }
  };

  if (!devolucion) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content-recepcion">
        <div className="modal-header">
          <h2>💰 Confirmar Liquidación de Vale</h2>
          <button className="btn-cerrar-modal" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {/* Información General */}
          <div className="seccion-info-general">
            <h3>Información del Vale a Liquidar</h3>
            <div className="info-grid-modal">
              <div className="info-item-modal">
                <label>Vale:</label>
                <span className="vale-destacado">{devolucion.ID_Vale}</span>
              </div>
              <div className="info-item-modal">
                <label>Cliente:</label>
                <span>{devolucion.Cliente}</span>
              </div>
              <div className="info-item-modal">
                <label>Ruta:</label>
                <span>{devolucion.Ruta}</span>
              </div>
              <div className="info-item-modal">
                <label>Fecha Ruta:</label>
                <span>{new Date(devolucion.Fecha_Ruta).toLocaleDateString()}</span>
              </div>
              <div className="info-item-modal">
                <label>Total Productos:</label>
                <span>{devolucion.DEV_DET.length} items</span>
              </div>
            </div>
          </div>

          {/* Resumen de Productos */}
          <div className="seccion-productos-recepcion">
            <h3>Resumen de Productos</h3>
            <div className="productos-recepcion-header">
              <div className="producto-col producto-cod-modal">Código</div>
              <div className="producto-col producto-nombre-modal">Producto</div>
              <div className="producto-col producto-cantidad-modal">Cantidad</div>
              <div className="producto-col producto-lote-modal">Lote</div>
              <div className="producto-col producto-motivo-modal">Motivo</div>
            </div>

            <div className="productos-recepcion-lista">
              {devolucion.DEV_DET.map((producto, index) => (
                <div key={producto.ID_Devolucion_Detalle} className="producto-recepcion-item">
                  <div className="producto-col producto-cod-modal">
                    <span className="producto-codigo">{producto.ID_Producto}</span>
                  </div>
                  <div className="producto-col producto-nombre-modal">
                    <span title={producto.ItemName}>
                      {producto.ItemName}
                    </span>
                  </div>
                  <div className="producto-col producto-cantidad-modal">
                    <span className="cantidad-original">{producto.Cantidad}</span>
                  </div>
                  <div className="producto-col producto-lote-modal">
                    {producto.Lote || "N/A"}
                  </div>
                  <div className="producto-col producto-motivo-modal">
                    <span
                      className="motivo-badge"
                      style={{
                        backgroundColor: motivosDevolucion[producto.ID_Motivo_Devolucion]?.color + '20',
                        color: motivosDevolucion[producto.ID_Motivo_Devolucion]?.color,
                        borderColor: motivosDevolucion[producto.ID_Motivo_Devolucion]?.color
                      }}
                    >
                      {motivosDevolucion[producto.ID_Motivo_Devolucion]?.texto || `Motivo ${producto.ID_Motivo_Devolucion}`}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            {/* Totales */}
            <div className="recepcion-totales">
              <div className="total-item">
                <span className="total-label">Total Productos:</span>
                <span className="total-value">{devolucion.DEV_DET.length} items</span>
              </div>
              <div className="total-item">
                <span className="total-label">Total Unidades:</span>
                <span className="total-value">
                  {devolucion.DEV_DET.reduce((sum, p) => sum + p.Cantidad, 0)} unidades
                </span>
              </div>
            </div>
          </div>

          {/* Mensaje de confirmación */}
          <div className="confirmacion-liquidacion">
            <div className="mensaje-confirmacion">
              <span className="icono-advertencia">⚠️</span>
              <div>
                <h4>¿Está seguro que desea liquidar este vale?</h4>
                <p>Esta acción cambiará el estado del vale a <strong>"Liquidado"</strong> y no se podrá revertir.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-cancelar" onClick={onClose} disabled={cargando}>
            Cancelar
          </button>
          <button
            className="btn-confirmar-liquidacion"
            onClick={handleConfirmar}
            disabled={cargando}
          >
            {cargando ? (
              <>
                <span className="btn-spinner"></span>
                Procesando...
              </>
            ) : (
              <>
                <span className="btn-icon">💰</span>
                Confirmar Liquidación
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

// Componente para el semáforo de tracking - Versión Mejorada
const TrackingSemaforo = ({ trackingData, estadoPrincipal }) => {
  // Usar el estado principal del encabezado como referencia principal
  const estadoActual = estadoPrincipal || 1;

  // Obtener el estado máximo del tracking para validación
  const maxEstadoTracking = trackingData && trackingData.length > 0
    ? Math.max(...trackingData.map(t => t.Id_Rastreo))
    : 1;

  // Determinar qué estados mostrar - MODIFICADO: estado 5 solo si está en tracking
  const getEstadosAMostrar = () => {
    const estadosAMostrar = [...ESTADOS];
    
    // Si no hay tracking data o no incluye el estado 5, filtrar el estado 5
    if (!trackingData || !trackingData.some(track => track.Id_Rastreo === 5)) {
      return estadosAMostrar.filter(estado => estado.id !== 5);
    }
    
    return estadosAMostrar;
  };

  const estadosAMostrar = getEstadosAMostrar();

  // Determinar los estados activos basados en el estado principal y el flujo de trabajo
  const getEstadosActivos = () => {
    const estadosActivos = new Set();

    // Siempre incluir el estado 1 (Creado) - estado inicial
    estadosActivos.add(1);

    // Agregar todos los estados hasta el estado actual principal, excluyendo el 5 si no está en tracking
    for (let i = 2; i <= estadoActual; i++) {
      if (i !== 5 || (trackingData && trackingData.some(track => track.Id_Rastreo === 5))) {
        estadosActivos.add(i);
      }
    }

    // Lógica especial para el flujo con estado 5 (No Recolectado)
    // Si el estado actual es 4 (Recolectado) pero pasó por 5 (No Recolectado),
    // también mostrar el estado 5 como alcanzado
    if (estadoActual >= 4 && trackingData) {
      const estadosEnTracking = trackingData.map(t => t.Id_Rastreo);
      if (estadosEnTracking.includes(5)) {
        estadosActivos.add(5);
      }
    }

    // Validar consistencia: si el tracking tiene estados más altos que el principal,
    // incluir esos estados también (por si hay discrepancias)
    if (maxEstadoTracking > estadoActual) {
      for (let i = estadoActual + 1; i <= maxEstadoTracking; i++) {
        if (i !== 5 || (trackingData && trackingData.some(track => track.Id_Rastreo === 5))) {
          estadosActivos.add(i);
        }
      }
    }

    return Array.from(estadosActivos).sort((a, b) => a - b);
  };

  const estadosActivos = getEstadosActivos();
  const estadoFinal = Math.max(estadoActual, maxEstadoTracking);
  const estadosEnTracking = trackingData ? trackingData.map(t => t.Id_Rastreo) : [];

  // Función para obtener información del usuario del tracking
  const getTrackingInfo = (estadoId) => {
    const track = trackingData?.find(t => t.Id_Rastreo === estadoId);
    return track ? {
      usuario: track.Usuario || 'Sistema',
      fecha: track.fecha
    } : null;
  };

  // Obtener información del estado actual
  const estadoInfo = ESTADOS.find(e => e.id === estadoFinal) || ESTADOS[0];
  const ultimoTracking = trackingData && trackingData.length > 0
    ? trackingData[trackingData.length - 1]
    : null;

  return (
    <div className="semaforo-container">
      <div className="semaforo-titulo">
        <h4>🚚 Seguimiento del Proceso</h4>
        <div className="estado-principal-badge">
          Estado Principal: <strong>{estadoInfo.nombre}</strong>
        </div>
      </div>

      {/* Contenedor principal del semáforo */}
      <div className="semaforo-completo">
        {/* Línea de puntos (iconos) */}
        <div className="semaforo-puntos-linea">
          {estadosAMostrar.map((estado, index) => {
            const isActive = estadosActivos.includes(estado.id);
            const isCurrent = estado.id === estadoFinal;
            const showConnector = index < estadosAMostrar.length - 1;
            const nextEstado = estadosAMostrar[index + 1];
            const isConnectorActive = isActive && nextEstado && estadosActivos.includes(nextEstado.id);
            const hasPassedThrough = estadosEnTracking.includes(estado.id);
            const trackingInfo = getTrackingInfo(estado.id);

            // Construir el tooltip con información del usuario
            const tooltipText = trackingInfo 
            ? `${estado.nombre} • ${trackingInfo.usuario} • ${new Date(trackingInfo.fecha).toLocaleDateString()}`
            : `${estado.nombre} ${isCurrent ? '(Actual)' : ''} ${hasPassedThrough ? '(Registrado)' : ''}`;

            return (
              <div key={`punto-${estado.id}`} className="semaforo-item">
                {/* Punto/Icono del estado */}
                <div className="semaforo-punto-container">
                  <div
                    className={`semaforo-punto ${isActive ? 'activo' : ''} ${isCurrent ? 'actual' : ''} ${hasPassedThrough ? 'con-tracking' : ''}`}
                    style={{
                      backgroundColor: isActive ? estado.color : '#E0E0E0',
                      borderColor: isActive ? estado.color : '#CCCCCC'
                    }}
                    title={tooltipText}
                  >
                    <span className="semaforo-icono">{estado.icon}</span>
                    {isCurrent && <div className="punto-glow"></div>}
                    {hasPassedThrough && !isCurrent && <div className="punto-check">✓</div>}
                  </div>

                  {/* Conector entre puntos */}
                  {showConnector && (
                    <div
                      className={`semaforo-conector ${isConnectorActive ? 'activo' : ''}`}
                      style={{
                        backgroundColor: isConnectorActive ? estado.color : '#E0E0E0'
                      }}
                    ></div>
                  )}
                </div>

                {/* Label del estado */}
                <div className="semaforo-label-container">
                  <span
                    className={`semaforo-label ${isActive ? 'activo' : ''} ${isCurrent ? 'actual' : ''}`}
                    style={{ color: isActive ? estado.color : '#666' }}
                  >
                    {estado.nombre}
                  </span>
                  {trackingInfo && (
                    <div className="semaforo-usuario-info" title={`Usuario: ${trackingInfo.usuario}`}>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Información del estado actual */}
      <div className="estado-info">
        <span className="estado-actual-texto">
          Estado actual: <strong style={{ color: estadoInfo.color }}>{estadoInfo.nombre}</strong>
        </span>
        {ultimoTracking && (
          <span className="estado-fecha">
            Última actualización: {new Date(ultimoTracking.fecha).toLocaleDateString()}
            {ultimoTracking.usuario && ` por ${ultimoTracking.usuario}`}
          </span>
        )}
      </div>

      {/* Información de consistencia */}
      {maxEstadoTracking !== estadoActual && (
        <div className="consistencia-info">
          <small>
            {maxEstadoTracking > estadoActual
              ? `⚠️ El tracking muestra estado más avanzado (${ESTADOS.find(e => e.id === maxEstadoTracking)?.nombre})`
              : `ℹ️ Estado principal: ${estadoInfo.nombre}`
            }
          </small>
        </div>
      )}
    </div>
  );
};

// Componente para mostrar los detalles de productos devueltos - VERSIÓN MEJORADA
const ProductosDetalle = ({ productos, estadoPrincipal }) => {
  const [expandido, setExpandido] = useState(false);

  const totalProductos = productos.reduce((sum, producto) => sum + producto.Cantidad, 0);

  // Verificar si el estado es "Recibido Bodega" (estado 6) o superior
  const esEstadoRecibido = estadoPrincipal >= 6;

  return (
    <div className="productos-detalle">
      <button
        className={`btn-expandir ${expandido ? 'expandido' : ''}`}
        onClick={() => setExpandido(!expandido)}
      >
        <span className="btn-expandir-texto">
          {expandido ? 'Ocultar' : 'Ver'} Productos ({productos.length} items, {totalProductos} unidades)
          {esEstadoRecibido && " - CON RECEPCIÓN"}
        </span>
        <span className="btn-expandir-icono">
          {expandido ? '▲' : '▼'}
        </span>
      </button>

      {expandido && (
        <div className="productos-lista-container">
          <div className="productos-lista">
            <div className="productos-header">
              <div className="producto-col producto-cod">Código</div>
              <div className="producto-col producto-nombre">Producto</div>
              <div className="producto-col producto-cantidad">Cantidad</div>
              {esEstadoRecibido && (
                <>
                  <div className="producto-col producto-cantidad-recibida">Cant. Recibida</div>
                  <div className="producto-col producto-observaciones-detalle">Observaciones</div>
                </>
              )}
              <div className="producto-col producto-lote">Lote</div>
              <div className="producto-col producto-vencimiento">Vencimiento</div>
              <div className="producto-col producto-motivo">Motivo</div>
            </div>
            {productos.map(producto => (
              <div key={producto.ID_Devolucion_Detalle} className="producto-item">
                <div className="producto-col producto-cod">
                  <span className="producto-codigo">{producto.ID_Producto}</span>
                </div>
                <div className="producto-col producto-nombre">
                  <span className="producto-nombre-texto" title={producto.ItemName}>
                    {producto.ItemName}
                  </span>
                </div>
                <div className="producto-col producto-cantidad">
                  <span className="cantidad-badge">{producto.Cantidad}</span>
                </div>
                {esEstadoRecibido && (
                  <>
                    <div className="producto-col producto-cantidad-recibida">
                      <span className="cantidad-recibida-badge">
                        {producto.cantidadRecepcion || producto.CantidadRecibida || 0}
                      </span>
                    </div>
                    <div className="producto-col producto-observaciones-detalle">
                      <span className="observaciones-texto" title={producto.observaciones || producto.Observaciones}>
                        {producto.observaciones || producto.Observaciones || "Sin observaciones"}
                      </span>
                    </div>
                  </>
                )}
                <div className="producto-col producto-lote">
                  {producto.Lote || "N/A"}
                </div>
                <div className="producto-col producto-vencimiento">
                  {producto.Fecha_Vencimiento
                    ? new Date(producto.Fecha_Vencimiento).toLocaleDateString()
                    : "N/A"}
                </div>
                <div className="producto-col producto-motivo">
                  <span
                    className="motivo-badge"
                    style={{
                      backgroundColor: motivosDevolucion[producto.ID_Motivo_Devolucion]?.color + '20',
                      color: motivosDevolucion[producto.ID_Motivo_Devolucion]?.color,
                      borderColor: motivosDevolucion[producto.ID_Motivo_Devolucion]?.color
                    }}
                  >
                    {motivosDevolucion[producto.ID_Motivo_Devolucion]?.texto || `Motivo ${producto.ID_Motivo_Devolucion}`}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

// Componente de tarjeta para cada devolución
const DevolucionCard = ({ devolucion, onRecibir, onLiquidar, userRole, productosCatalogo }) => {
  const [expandido, setExpandido] = useState(false);
  const [mostrarModalRecepcion, setMostrarModalRecepcion] = useState(false);
  const [mostrarModalLiquidacion, setMostrarModalLiquidacion] = useState(false);

  // Obtener el estado principal del encabezado
  const estadoPrincipal = devolucion.Id_Rastreo || 1;

  // Calcular el progreso basado en el estado actual
  const getProgreso = (tracking, estadoPrincipal) => {
    const estadoFinal = Math.max(
      estadoPrincipal,
      tracking && tracking.length > 0 ? Math.max(...tracking.map(t => t.Id_Rastreo)) : 1
    );

    const porcentajes = {
      1: 12,   // Creado
      2: 25,   // Autorizado Ventas
      3: 37,   // Asignado
      4: 50,   // Recolectado
      5: 62,   // No Recolectado
      6: 75,   // Recibido Bodega
      7: 87,   // Liquidado
      8: 100   // Cargado a SAP
    };

    const estadosNombres = {
      1: "Creado",
      2: "Autorizado",
      3: "Asignado",
      4: "Recolectado",
      5: "No Recolectado",
      6: "Recibido",
      7: "Liquidado",
      8: "SAP"
    };

    return {
      porcentaje: porcentajes[estadoFinal] || 12,
      estado: estadosNombres[estadoFinal] || "Creado"
    };
  };

  const progreso = getProgreso(devolucion.DEV_TRACKING, estadoPrincipal);
  const tieneTracking = devolucion.DEV_TRACKING && devolucion.DEV_TRACKING.length > 0;

  // Función para manejar el clic en el botón Recibir
  const handleRecibir = async (e) => {
    e.stopPropagation();
    setMostrarModalRecepcion(true);
  };

  // Función para manejar el clic en el botón Liquidar
  const handleLiquidar = async (e) => {
    e.stopPropagation();
    setMostrarModalLiquidacion(true);
  };

  // Función para manejar la confirmación de recepción desde el modal
  const handleConfirmarRecepcion = async (datosRecepcion) => {
    try {
      await onRecibir(datosRecepcion);
      setMostrarModalRecepcion(false);
    } catch (error) {
      console.error('Error al confirmar recepción:', error);
      throw error;
    }
  };

  // Función para manejar la confirmación de liquidación desde el modal
  const handleConfirmarLiquidacion = async (datosLiquidacion) => {
    try {
      await onLiquidar(datosLiquidacion);
      setMostrarModalLiquidacion(false);
    } catch (error) {
      console.error('Error al confirmar liquidación:', error);
      throw error;
    }
  };

  // Determinar qué botones mostrar según el rol y estado
  const mostrarBotonRecibir = userRole === 'Bodega' && estadoPrincipal < 6;
  const mostrarBotonLiquidar = userRole === 'Liquidador' && estadoPrincipal === 6;

  return (
    <>
      <div className={`devolucion-card ${expandido ? 'expandido' : ''} ${tieneTracking ? 'con-tracking' : 'sin-tracking'}`}>
        <div className="devolucion-header" onClick={() => setExpandido(!expandido)}>
          <div className="devolucion-info">
            <div className="devolucion-cliente">
              <h3>{devolucion.Cliente}</h3>
              <span className="cliente-id">ID: {devolucion.ID_Cliente}</span>
              <span className={`estado-badge estado-${progreso.estado.replace(/\s+/g, '-').toLowerCase()}`}>
                {progreso.estado}
              </span>
            </div>
            <div className="devolucion-meta">
              <div className="meta-item">
                <span className="meta-label">Vale:</span>
                <span className="meta-value vale-id">{devolucion.ID_Vale}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">Ruta:</span>
                <span className="meta-value ruta-badge">{devolucion.Ruta}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">Fecha:</span>
                <span className="meta-value">{new Date(devolucion.Fecha_Ruta).toLocaleDateString()}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">Estado Principal:</span>
                <span className="meta-value estado-principal">
                  {estadosDevolucion[estadoPrincipal] || "Creado"}
                </span>
              </div>
            </div>
          </div>

          <div className="devolucion-estado">
            <div className="estado-progreso">
              <div className="progreso-bar">
                <div
                  className="progreso-fill"
                  style={{ width: `${progreso.porcentaje}%` }}
                ></div>
              </div>
              <span className="estado-actual">{progreso.estado}</span>
            </div>
            <div className="devolucion-acciones-principales">
              <div className="productos-count">
                <span className="count-badge">
                  {devolucion.DEV_DET.length} producto{devolucion.DEV_DET.length !== 1 ? 's' : ''}
                </span>
              </div>

              {/* Botones según rol */}
              {mostrarBotonRecibir && (
                <button
                  className="btn-recibir"
                  onClick={handleRecibir}
                  title="Marcar como recibido en bodega"
                >
                  <span className="btn-icon">📥</span>
                  Recibir
                </button>
              )}

              {mostrarBotonLiquidar && (
                <button
                  className="btn-liquidar"
                  onClick={handleLiquidar}
                  title="Liquidar vale"
                >
                  <span className="btn-icon">💰</span>
                  Liquidar
                </button>
              )}
            </div>
          </div>

          <div className="devolucion-acciones">
            <span className={`expand-icon ${expandido ? 'expandido' : ''}`}>
              {expandido ? '▲' : '▼'}
            </span>
          </div>
        </div>

        {expandido && (
          <div className="devolucion-detalles">
            <div className="detalle-seccion">
              <h4 className="seccion-titulo">📋 Información General</h4>
              <div className="info-grid-detalle">
                <div className="info-grupo">
                  <label>Dirección:</label>
                  <span>{devolucion.Direccion}</span>
                </div>
                <div className="info-grupo">
                  <label>Tipo Documento:</label>
                  <span>{devolucion.Tipo_Documento}</span>
                </div>
                <div className="info-grupo">
                  <label>Subruta:</label>
                  <span>{devolucion.SubRuta || "N/A"}</span>
                </div>
                <div className="info-grupo">
                  <label>Parada:</label>
                  <span>{devolucion.Parada || "N/A"}</span>
                </div>
                <div className="info-grupo">
                  <label>Estado Principal (Id_Rastreo):</label>
                  <span className="estado-principal-value">
                    {estadoPrincipal} - {estadosDevolucion[estadoPrincipal] || "Creado"}
                  </span>
                </div>
              </div>
              {devolucion.Comentarios && (
                <div className="comentarios-grupo">
                  <label>Comentarios:</label>
                  <p className="comentarios-texto">{devolucion.Comentarios}</p>
                </div>
              )}
            </div>

            <div className="detalle-seccion">
              <TrackingSemaforo
                trackingData={devolucion.DEV_TRACKING}
                estadoPrincipal={estadoPrincipal}
              />
            </div>

            <div className="detalle-seccion">
              <h4 className="seccion-titulo">📦 Productos Devueltos</h4>
              <ProductosDetalle
                productos={devolucion.DEV_DET}
                estadoPrincipal={estadoPrincipal}
              />
            </div>

            {devolucion.DEV_TRACKING && devolucion.DEV_TRACKING.length > 0 && (
              <div className="detalle-seccion">
                <h4 className="seccion-titulo">📊 Historial de Tracking</h4>
                <div className="tracking-lista">
                  {devolucion.DEV_TRACKING.map(track => (
                    <div key={`${track.Id_Rastreo}-${track.fecha}`} className="tracking-item">
                      <div className="tracking-info">
                        <span className="track-estado">
                          Estado {track.Id_Rastreo}: {estadosDevolucion[track.Id_Rastreo] || `Estado ${track.Id_Rastreo}`}
                        </span>
                        <span className="track-fecha">
                          {new Date(track.fecha).toLocaleString()}
                        </span>
                        {track.usuario && (
                          <span className="track-usuario" title={`Usuario: ${track.usuario}`}>
                            👤 {track.usuario}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Modal de Recepción */}
      {mostrarModalRecepcion && (
        <ModalRecepcion
          devolucion={devolucion}
          onClose={() => setMostrarModalRecepcion(false)}
          onConfirmarRecepcion={handleConfirmarRecepcion}
          productosCatalogo={productosCatalogo}
        />
      )}

      {/* Modal de Liquidación */}
      {mostrarModalLiquidacion && (
        <ModalLiquidacion
          devolucion={devolucion}
          onClose={() => setMostrarModalLiquidacion(false)}
          onConfirmarLiquidacion={handleConfirmarLiquidacion}
        />
      )}
    </>
  );
};

// Componente de filtros
const Filtros = ({ datos, onFiltrar }) => {
  const [filtros, setFiltros] = useState({
    vale: '',
    ruta: '',
    cliente: '',
    fechaDesde: '',
    fechaHasta: '',
    estado: '',
    motivo: ''
  });

  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [mostrarListaAutocompletar, setMostrarListaAutocompletar] = useState({
    vale: false,
    ruta: false,
    cliente: false,
    estado: false,
    motivo: false
  });

  // Calcular opciones para cada filtro
  const calcularOpciones = () => {
    const opciones = {
      vales: [],
      rutas: [],
      clientes: [],
      estados: [],
      motivos: []
    };

    const counts = {
      vales: {},
      rutas: {},
      clientes: {},
      estados: {},
      motivos: {}
    };

    datos.forEach(devolucion => {
      // Count para vales
      const vale = devolucion.ID_Vale || 'Sin Vale';
      counts.vales[vale] = (counts.vales[vale] || 0) + 1;

      // Count para rutas
      const ruta = devolucion.Ruta || 'Sin Ruta';
      counts.rutas[ruta] = (counts.rutas[ruta] || 0) + 1;

      // Count para clientes
      const cliente = devolucion.Cliente || 'Sin Cliente';
      counts.clientes[cliente] = (counts.clientes[cliente] || 0) + 1;

      // Count para estados (basado en Id_Rastreo del encabezado)
      const estadoPrincipal = devolucion.Id_Rastreo || 1;
      counts.estados[estadoPrincipal] = (counts.estados[estadoPrincipal] || 0) + 1;

      // Count para motivos (basado en los productos)
      if (devolucion.DEV_DET && devolucion.DEV_DET.length > 0) {
        devolucion.DEV_DET.forEach(producto => {
          const motivoId = producto.ID_Motivo_Devolucion;
          if (motivoId) {
            counts.motivos[motivoId] = (counts.motivos[motivoId] || 0) + 1;
          }
        });
      }
    });

    // Convertir counts a opciones para autocompletar
    opciones.vales = Object.entries(counts.vales)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([vale, count]) => ({
        texto: vale,
        valor: vale,
        count: count
      }));

    opciones.rutas = Object.entries(counts.rutas)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([ruta, count]) => ({
        texto: ruta,
        valor: ruta,
        count: count
      }));

    opciones.clientes = Object.entries(counts.clientes)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([cliente, count]) => ({
        texto: cliente,
        valor: cliente,
        count: count
      }));

    opciones.estados = Object.entries(counts.estados)
      .sort(([a], [b]) => parseInt(a) - parseInt(b))
      .map(([estadoId, count]) => ({
        texto: estadosDevolucion[estadoId] || `Estado ${estadoId}`,
        valor: estadoId,
        count: count
      }));

    opciones.motivos = Object.entries(counts.motivos)
      .sort(([a], [b]) => parseInt(a) - parseInt(b))
      .map(([motivoId, count]) => ({
        texto: motivosDevolucion[motivoId]?.texto || `Motivo ${motivoId}`,
        valor: motivoId,
        count: count
      }));

    return opciones;
  };

  const opciones = calcularOpciones();

  const handleFiltroChange = (campo, valor) => {
    const nuevosFiltros = { ...filtros, [campo]: valor };
    setFiltros(nuevosFiltros);
  };

  const handleFiltroSeleccionar = (campo, valor) => {
    const nuevosFiltros = { ...filtros, [campo]: valor };
    setFiltros(nuevosFiltros);
    onFiltrar(nuevosFiltros);
    setMostrarListaAutocompletar(prev => ({ ...prev, [campo]: false }));
  };

  const handleMostrarListaChange = (campo, mostrar) => {
    setMostrarListaAutocompletar(prev => ({ ...prev, [campo]: mostrar }));
  };

  const limpiarFiltros = () => {
    const filtrosVacios = {
      vale: '',
      ruta: '',
      cliente: '',
      fechaDesde: '',
      fechaHasta: '',
      estado: '',
      motivo: ''
    };
    setFiltros(filtrosVacios);
    onFiltrar(filtrosVacios);
  };

  const filtrosActivos = Object.values(filtros).filter(valor => valor !== '').length;

  return (
    <div className="filtros-container">
      <div className="filtros-header">
        <h3>Filtros</h3>
        <button
          className={`btn-filtros-toggle ${mostrarFiltros ? 'activo' : ''}`}
          onClick={() => setMostrarFiltros(!mostrarFiltros)}
        >
          <span>Filtros {filtrosActivos > 0 && `(${filtrosActivos})`}</span>
          <span className="toggle-icon">{mostrarFiltros ? '▲' : '▼'}</span>
        </button>
      </div>

      {mostrarFiltros && (
        <div className="filtros-content">
          <div className="filtros-grid">
            {/* Filtro por Vale con Autocompletar */}
            <div className="filtro-grupo">
              <label className="filtro-label-with-count">
                Vale <span className="count-badge-filtro">({opciones.vales.length})</span>
              </label>
              <Autocompletar
                value={filtros.vale}
                onChange={(valor) => handleFiltroChange('vale', valor)}
                opciones={opciones.vales}
                placeholder="Buscar vale..."
                onSeleccionar={(valor) => handleFiltroSeleccionar('vale', valor)}
                mostrarLista={mostrarListaAutocompletar.vale}
                onMostrarListaChange={(mostrar) => handleMostrarListaChange('vale', mostrar)}
              />
            </div>

            {/* Filtro por Ruta con Autocompletar */}
            <div className="filtro-grupo">
              <label className="filtro-label-with-count">
                Ruta <span className="count-badge-filtro">({opciones.rutas.length})</span>
              </label>
              <Autocompletar
                value={filtros.ruta}
                onChange={(valor) => handleFiltroChange('ruta', valor)}
                opciones={opciones.rutas}
                placeholder="Buscar ruta..."
                onSeleccionar={(valor) => handleFiltroSeleccionar('ruta', valor)}
                mostrarLista={mostrarListaAutocompletar.ruta}
                onMostrarListaChange={(mostrar) => handleMostrarListaChange('ruta', mostrar)}
              />
            </div>

            {/* Filtro por Cliente con Autocompletar */}
            <div className="filtro-grupo">
              <label className="filtro-label-with-count">
                Cliente <span className="count-badge-filtro">({opciones.clientes.length})</span>
              </label>
              <Autocompletar
                value={filtros.cliente}
                onChange={(valor) => handleFiltroChange('cliente', valor)}
                opciones={opciones.clientes}
                placeholder="Buscar cliente..."
                onSeleccionar={(valor) => handleFiltroSeleccionar('cliente', valor)}
                mostrarLista={mostrarListaAutocompletar.cliente}
                onMostrarListaChange={(mostrar) => handleMostrarListaChange('cliente', mostrar)}
              />
            </div>

            {/* Filtros de fecha (sin cambios) */}
            <div className="filtro-grupo">
              <label>Fecha Desde</label>
              <input
                type="date"
                name="fechaDesde"
                value={filtros.fechaDesde}
                onChange={(e) => {
                  const nuevosFiltros = { ...filtros, fechaDesde: e.target.value };
                  setFiltros(nuevosFiltros);
                  onFiltrar(nuevosFiltros);
                }}
              />
            </div>

            <div className="filtro-grupo">
              <label>Fecha Hasta</label>
              <input
                type="date"
                name="fechaHasta"
                value={filtros.fechaHasta}
                onChange={(e) => {
                  const nuevosFiltros = { ...filtros, fechaHasta: e.target.value };
                  setFiltros(nuevosFiltros);
                  onFiltrar(nuevosFiltros);
                }}
              />
            </div>

            {/* Filtro por Estado con Autocompletar */}
            <div className="filtro-grupo">
              <label className="filtro-label-with-count">
                Estado <span className="count-badge-filtro">({opciones.estados.length})</span>
              </label>
              <Autocompletar
                value={filtros.estado ? (estadosDevolucion[filtros.estado] || `Estado ${filtros.estado}`) : ''}
                onChange={(valor) => {
                  // Buscar el ID del estado basado en el texto
                  const estadoEncontrado = opciones.estados.find(op => op.texto === valor);
                  if (estadoEncontrado) {
                    handleFiltroChange('estado', estadoEncontrado.valor);
                  } else {
                    handleFiltroChange('estado', '');
                  }
                }}
                opciones={opciones.estados}
                placeholder="Buscar estado..."
                onSeleccionar={(valor) => handleFiltroSeleccionar('estado', valor)}
                mostrarLista={mostrarListaAutocompletar.estado}
                onMostrarListaChange={(mostrar) => handleMostrarListaChange('estado', mostrar)}
              />
            </div>

            {/* Filtro por Motivo con Autocompletar */}
            <div className="filtro-grupo">
              <label className="filtro-label-with-count">
                Motivo <span className="count-badge-filtro">({opciones.motivos.length})</span>
              </label>
              <Autocompletar
                value={filtros.motivo ? (motivosDevolucion[filtros.motivo]?.texto || `Motivo ${filtros.motivo}`) : ''}
                onChange={(valor) => {
                  // Buscar el ID del motivo basado en el texto
                  const motivoEncontrado = opciones.motivos.find(op => op.texto === valor);
                  if (motivoEncontrado) {
                    handleFiltroChange('motivo', motivoEncontrado.valor);
                  } else {
                    handleFiltroChange('motivo', '');
                  }
                }}
                opciones={opciones.motivos}
                placeholder="Buscar motivo..."
                onSeleccionar={(valor) => handleFiltroSeleccionar('motivo', valor)}
                mostrarLista={mostrarListaAutocompletar.motivo}
                onMostrarListaChange={(mostrar) => handleMostrarListaChange('motivo', mostrar)}
              />
            </div>
          </div>

          <div className="filtros-acciones">
            <button className="btn-limpiar" onClick={limpiarFiltros}>
              <span className="limpiar-icon">🗑️</span>
              Limpiar Filtros
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// Componente principal
const App = () => {
  const { user } = useSelector(state => state.auth);
  const [datosOriginales, setDatosOriginales] = useState([]);
  const [datosFiltrados, setDatosFiltrados] = useState([]);
  const [productosCatalogo, setProductosCatalogo] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  const [validacionExitosa, setValidacionExitosa] = useState(true);
  const [notifications, setNotifications] = useState([]);

  // Función para determinar el rol del usuario basado en los Id_Perfil
  const determinarRolUsuario = useCallback(() => {
    if (!user || !user.rol || !Array.isArray(user.rol)) {
      return 'Visualizador';
    }

    // Extraer los Id_Perfil del array de roles
    const perfiles = user.rol.map(rol => rol.Id_Perfil);

    // Verificar si tiene el perfil de Liquidador (170010)
    if (perfiles.includes(200100)) {
      return 'Liquidador';
    }

    if (perfiles.includes(200000)) {
      return 'Bodega';
    }

    // Por defecto, solo visualización
    return 'Visualizador';
  }, [user]);

  const userRole = determinarRolUsuario();

  // Función para agregar notificaciones
  const addNotification = useCallback((type, title, message) => {
    const id = Date.now() + Math.random();
    const newNotification = {
      id,
      type,
      title,
      message,
      timestamp: new Date()
    };

    setNotifications(prev => [...prev, newNotification]);

    // Auto-remover después de 10 segundos
    setTimeout(() => {
      removeNotification(id);
    }, 10000);
  }, []);

  // Función para remover notificaciones
  const removeNotification = useCallback((id) => {
    setNotifications(prev => prev.filter(notification => notification.id !== id));
  }, []);

  // Función para cargar productos del catálogo
  const cargarProductos = useCallback(async () => {
    
    console.log('------- 1711');
    try {
      const response = await apiService.get("ObtenerProductos", {}, user);
      console.log(response.datos_Generados)
      const data2 = response.datos_Generados  
      const data  = JSON.parse(data2);
       console.log('DATA--------654654654', data);
     console.log(data.PRODUCTOS); 
     console.log('DATA ---------- /////--------------------------------')
      if (data && data.PRODUCTOS) {
        // Transformar los datos al formato que espera el componente
        console.log("PRODUCTOS : -----------" , data.PRODUCTOS)
        const productosTransformados = data.PRODUCTOS.map(producto => ({
          ID_Producto: producto.ItemCode,
          ItemName: producto.ItemName,
           Lote: "", // Puedes ajustar esto según tus necesidades
           Fecha_Vencimiento: "" // Valor por defecto
           
        }));
        console.log("PRODUCTOS TRANSFORMADOS: -----------" , productosTransformados);
        setProductosCatalogo(productosTransformados);
      }
    } catch (error) {
      console.error('Error al cargar productos:', error);
      addNotification('error', 'Error', 'No se pudieron cargar los productos');
    }
  }, [user, addNotification]);

  // Usar useCallback para memoizar la función y evitar recreaciones innecesarias
  const cargarDatos = useCallback(async () => {
    try {
      setCargando(true);
      setError(null);

      const structura = { Fecha: "20251008" };
      const response = await apiService.get("ObtenerDevolucionesLiquidaciones", structura, user);
      const data = response;
      const datosGenerados = JSON.parse(data.datos_Generados);
      console.log('Datos Generados (JSON):', datosGenerados);

      setDatosOriginales(datosGenerados);
      setDatosFiltrados(datosGenerados);

    } catch (err) {
      const errorMsg = "Error al cargar los datos: " + err.message;
      setError(errorMsg);
      console.error('Error cargando datos:', err);

      // Mostrar notificación de error
      addNotification('error', 'Error al cargar', errorMsg);
    } finally {
      setCargando(false);
    }

  }, [user, addNotification]);

  // Función para recibir una devolución - VERSIÓN CORREGIDA
  const recibirDevolucion = async (datosRecepcion) => {
    try {
      console.log('Recibiendo devolución con datos T1:', datosRecepcion);

      // Aquí invocarías tu API para recibir la devolución
      const response = await apiService.post("GenerarRecepcionValesBodega", datosRecepcion, user);
      console.log('Datos Generados POST T1: ', response);
      const resp = JSON.parse(response.datos_Generados);

      if (resp && resp.Mensaje === "Vale Actualizado con Exito") {
        setValidacionExitosa(true);

        // Mostrar notificación de éxito
        addNotification(
          'success',
          'Recepción exitosa',
          `Se ha recibido el vale ${datosRecepcion.ID_Vale} correctamente`
        );

        // Esperar 10 segundos antes de recargar los datos
        setTimeout(() => {
          cargarDatos();
        }, 10000);

      } else {
        setValidacionExitosa(false);
        throw new Error("Validación fallida: No se puede recibir esta devolución");
      }

    } catch (error) {
      console.error('Error al recibir devolución:', error);

      // Mostrar notificación de error
      addNotification(
        'error',
        'Error en recepción',
        `Error al recibir el vale ${datosRecepcion?.ID_Vale}: ${error.message}`
      );
      throw error;
    }
  };

  // Función para liquidar una devolución
  const liquidarDevolucion = async (datosLiquidacion) => {
    try {
      console.log('Liquidando devolución con datos:', datosLiquidacion);

      // Llamar a la API para liquidar el vale
      const response = await apiService.post("GenerarRecepcionValesLiquidacion", datosLiquidacion, user);
      console.log('Datos Generados POST Liquidación: ', response);
      const resp = JSON.parse(response.datos_Generados);

      if (resp && resp.Mensaje === "Vale Liquidado con Exito") {
        setValidacionExitosa(true);

        // Mostrar notificación de éxito
        addNotification(
          'success',
          'Liquidación exitosa',
          `Se ha liquidado el vale ${datosLiquidacion.ID_Vale} correctamente`
        );

        // Esperar 10 segundos antes de recargar los datos
        setTimeout(() => {
          cargarDatos();
        }, 10000);

      } else {
        setValidacionExitosa(false);
        throw new Error("Validación fallida: No se puede liquidar este vale");
      }

    } catch (error) {
      console.error('Error al liquidar devolución:', error);

      // Mostrar notificación de error
      addNotification(
        'error',
        'Error en liquidación',
        `Error al liquidar el vale ${datosLiquidacion?.ID_Vale}: ${error.message}`
      );
      throw error;
    }
  };

  const aplicarFiltros = (filtros) => {
    let datosFiltrados = [...datosOriginales];

    if (filtros.vale) {
      datosFiltrados = datosFiltrados.filter(d => d.ID_Vale === filtros.vale);
    }

    if (filtros.ruta) {
      datosFiltrados = datosFiltrados.filter(d => d.Ruta === filtros.ruta);
    }

    if (filtros.cliente) {
      datosFiltrados = datosFiltrados.filter(d => d.Cliente === filtros.cliente);
    }

    if (filtros.fechaDesde) {
      datosFiltrados = datosFiltrados.filter(d =>
        new Date(d.Fecha_Ruta) >= new Date(filtros.fechaDesde)
      );
    }

    if (filtros.fechaHasta) {
      datosFiltrados = datosFiltrados.filter(d =>
        new Date(d.Fecha_Ruta) <= new Date(filtros.fechaHasta)
      );
    }

    if (filtros.estado) {
      datosFiltrados = datosFiltrados.filter(d => {
        const estadoPrincipal = d.Id_Rastreo || 1;
        return estadoPrincipal.toString() === filtros.estado;
      });
    }

    if (filtros.motivo) {
      datosFiltrados = datosFiltrados.filter(d =>
        d.DEV_DET.some(producto => producto.ID_Motivo_Devolucion.toString() === filtros.motivo)
      );
    }

    setDatosFiltrados(datosFiltrados);
  };

  useEffect(() => {
    const dat = {};
    apiService.logactivity('LiquidacionVales','',dat,user);
    cargarDatos();
    cargarProductos();
  }, [cargarDatos, cargarProductos]);

  if (cargando) {
    return (
      <div className="app">
        <div className="cargando-container">
          <div className="spinner"></div>
          <p>Cargando datos de devoluciones...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="app">
        <div className="error-container">
          <div className="error-icon">⚠️</div>
          <h2>Error al cargar los datos</h2>
          <p>{error}</p>
          <button className="btn-reintentar" onClick={cargarDatos}>
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      {/* Sistema de Notificaciones */}
      <NotificationSystem
        notifications={notifications}
        onRemoveNotification={removeNotification}
      />

      <header className="app-header">
        <div className="header-content">
          <div className="header-titulo">
            <h1>📦 Sistema de Seguimiento de Devoluciones</h1>
            <p>Gestión y monitoreo de devoluciones en tiempo real</p>
            <div className="user-role-badge">
              Rol: <strong>{userRole}</strong>
              {user?.rol && (
                <span className="user-perfiles">
                  (Perfiles: {user.rol.map(r => r.Id_Perfil).join(', ')})
                </span>
              )}
            </div>
          </div>
          <div className="header-stats">
            <div className="stat-card">
              <span className="stat-numero">{datosFiltrados.length}</span>
              <span className="stat-label">Devoluciones</span>
            </div>
            <button className="btn-actualizar" onClick={cargarDatos}>
              <span className="btn-icon">🔄</span>
              Actualizar
            </button>
          </div>
        </div>
      </header>

      <main className="app-main">
        <Filtros
          datos={datosOriginales}
          onFiltrar={aplicarFiltros}
        />

        <div className="resultados-container">
          <div className="resultados-header">
            <h2>Devoluciones Encontradas</h2>
            <div className="resultados-info">
              <span className="resultados-count">{datosFiltrados.length} resultado{datosFiltrados.length !== 1 ? 's' : ''}</span>
              {datosFiltrados.length !== datosOriginales.length && (
                <span className="filtros-activos-badge">
                  Filtros aplicados
                </span>
              )}
            </div>
          </div>

          {datosFiltrados.length === 0 ? (
            <div className="sin-resultados">
              <div className="sin-resultados-icon">🔍</div>
              <h3>No se encontraron devoluciones</h3>
              <p>Intenta ajustar los filtros para ver más resultados.</p>
            </div>
          ) : (
            <div className="devoluciones-lista">
              {datosFiltrados.map(devolucion => (
                <DevolucionCard
                  key={devolucion.ID_Devolucion}
                  devolucion={devolucion}
                  onRecibir={recibirDevolucion}
                  onLiquidar={liquidarDevolucion}
                  userRole={userRole}
                  productosCatalogo={productosCatalogo}
                />
              ))}
            </div>
          )}
        </div>
      </main>

      <footer className="app-footer">
        <p>© {new Date().getFullYear()} Sistema de Devoluciones - Todos los derechos reservados</p>
      </footer>
    </div>
  );
};

export default App;